import React from 'react';

// CompCycleControl — the shared company-level compensation-cycle control.
// TWO numeric offsets, one per comp type: BONUS payout timing (bonus_payout_delay_months) and
// COMMISSION payment lag (commission_delay_months). comp_cycle_basis is a fixed calendar
// alignment (not a user choice), so it has no selector here. `onChange(patch)` receives
// { bonus_payout_delay_months } or { commission_delay_months } and the caller persists via
// updateCompanySettings (Step-9 saveCf; Payroll-tab saveCompanySettings). No engine touch — the
// engine derives each null bonus/commission anchor at compute time from these offsets.

const FONT = "'DM Sans',-apple-system,sans-serif";
const selStyle = { fontSize: 12, padding: '6px 10px', borderRadius: 6, border: '1px solid #D1D5DB', cursor: 'pointer', fontFamily: FONT, color: '#1A1C2E', background: '#fff' };
const labelStyle = { fontSize: 11, fontWeight: 700, color: '#5A5FC0', textTransform: 'uppercase', letterSpacing: '0.4px', fontFamily: FONT };
const OFFSETS = [0, 1, 2];
const bonusLabel = o => o === 0 ? '0 — at period-end' : o + ' month' + (o > 1 ? 's' : '') + ' after period-end';
const lagLabel = o => o === 0 ? '0 — no lag' : o + ' month' + (o > 1 ? 's' : '');

export default function CompCycleControl({ bonusDelay, lag, onChange, style }) {
  return (
    <div style={{
      padding: '14px 18px', borderRadius: 12, background: 'rgba(90,95,192,0.04)',
      border: '1px solid rgba(90,95,192,0.14)', fontFamily: FONT, ...style,
    }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#1A1C2E', marginBottom: 10 }}>Compensation Cycle</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <span style={labelStyle}>Bonus Payout Timing</span>
          <select value={String(bonusDelay ?? 0)} onChange={e => onChange({ bonus_payout_delay_months: parseInt(e.target.value, 10) || 0 })} style={selStyle}>
            {OFFSETS.map(o => <option key={o} value={o}>{bonusLabel(o)}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <span style={labelStyle}>Commission Payment Lag</span>
          <select value={String(lag ?? 0)} onChange={e => onChange({ commission_delay_months: parseInt(e.target.value, 10) || 0 })} style={selStyle}>
            {OFFSETS.map(o => <option key={o} value={o}>{lagLabel(o)}</option>)}
          </select>
        </div>
      </div>
      <div style={{ fontSize: 11, color: '#8B8FA3', marginTop: 10, lineHeight: 1.5 }}>
        Employees inherit their bonus/commission anchor from this cycle unless overridden per employee.
        Bonuses pay at each calendar period-end plus the Bonus Payout Timing offset; commissions pay at
        cycle close plus the Commission Payment Lag. The two are independent.
      </div>
    </div>
  );
}
